import React from "react";
import {Box, IconButton, Tooltip} from "@mui/material";
import {FullscreenExitRounded, FullscreenRounded} from "@mui/icons-material";
import {useTranslation} from "react-i18next";


const getDocumentFullScreenElement = () => {
    return document.msFullscreenElement ?? document.webkitFullscreenElement ?? document.mozFullScreenElement ?? document.fullscreenElement;
}
const getDocumentFullScreenRequestMethod = () => {
    return (document.documentElement.msRequestFullscreen ?? document.documentElement.webkitRequestFullscreen ?? document.documentElement.mozRequestFullScreen ?? document.documentElement.requestFullscreen).bind(document.documentElement);
}

const getDocumentExitFullScreenMethod = () => {
    return (document.msExitFullscreen ?? document.webkitExitFullscreen ?? document.mozCancelFullScreen ?? document.exitFullscreen).bind(document);
}

export const FullScreenButton: React.FC = () => {
    const [fulLScreen, setFulLScreen] = React.useState(!!getDocumentFullScreenElement())
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.drawers.settings-drawer.full-screen-button'});

    /**
     * Listens for changes in the full-screen state of the document and updates the component state accordingly.
     */
    React.useEffect(() => {
        const listener = () => {
            setFulLScreen(!!getDocumentFullScreenElement());
        }
        document.addEventListener('fullscreenchange', listener);
        return () => {
            document.removeEventListener('fullscreenchange', listener);
        }
    }, [])

    /**
     * Toggles the full-screen mode of the document.
     */
    const toggleFullScreen = React.useCallback(() => {
        if (!!getDocumentFullScreenElement()) {
            const exitMethod = getDocumentExitFullScreenMethod();
            try {
                void exitMethod()
            } catch {
            }
            setFulLScreen(false);
        } else {
            const requestMethod = getDocumentFullScreenRequestMethod();
            try {
                void requestMethod()
            } catch {
            }
            setFulLScreen(true);
        }
    }, []);

    return (
        <>
            <Tooltip title={fulLScreen ? t(t => t.exit) : t(t => t.enter)}>
                <IconButton onClick={toggleFullScreen} color={'default'} sx={{width: 34, height: 34, minWidth: 34,}}>
                    {
                        fulLScreen &&
                        <Box component={FullscreenExitRounded} sx={{width: 20, height: 20}}/>
                    }
                    {
                        !fulLScreen &&
                        <Box component={FullscreenRounded} sx={{width: 20, height: 20}}/>
                    }
                </IconButton>
            </Tooltip>
        </>
    );
}